"use client";

export default function GlobalErrorPage({ reset }: { error: Error; reset: () => void }) {
  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#F9F6F0",
          color: "#4A1118",
          fontFamily: "Georgia, serif",
          textAlign: "center",
        }}
      >
        <main>
          <p style={{ margin: 0, color: "#E65100", fontWeight: 700, letterSpacing: "0.08em" }}>500</p>
          <h1 style={{ margin: "10px 0", fontSize: "36px" }}>Something went wrong</h1>
          <p style={{ margin: "0 0 22px", color: "#5c1d2a" }}>Please try again in a moment.</p>
          <button
            type="button"
            onClick={() => reset()}
            style={{
              background: "#E65100",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              padding: "10px 18px",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </main>
      </body>
    </html>
  );
}
